/** @format */

import { InjectionToken } from '@angular/core';

/**
 * Propagates the given error object to the higher layer in the server.
 */
export const PROPAGATE_ERROR_TO_SERVER = new InjectionToken<(error: unknown) => void>(
	'PROPAGATE_ERROR_RESPONSE'
);
